import Swiper from 'swiper/bundle'; // css file is added locally

let fontSize = parseFloat($('body').css('font-size'));

const swiperLogos = new Swiper('.logos__slider', {
    loop: true,
    autoplay: {
        delay: 1
    },
    speed: 5000,
    slidesPerView: 3,
    spaceBetween: '10%',
    allowTouchMove: false,
    breakpoints: {
        481: { // when window is >=
            slidesPerView: 4,
            spaceBetween: '8.5%',
        },
        676: { // when window is >=
            slidesPerView: 5,
            spaceBetween: '7.5%',
        }
    }
});

const swiperPortfolio = new Swiper('.portfolio__slider', {
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: (fontSize*2),
    speed: 300,
    loop: true,
    autoHeight: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
});


// https://stackoverflow.com/questions/43801782/swiper-continous-loop-without-pause-between-sliding